// Returns true if return datetime is AFTER pickup datetime
export const isReturnAfterPickup = (
  pickupDate: Date,
  pickupHours: number,
  pickupMinutes: number,
  returnDate: Date,
  returnHours: number,
  returnMinutes: number
): boolean => {
  const pickup = new Date(pickupDate);
  pickup.setHours(pickupHours, pickupMinutes, 0, 0);

  const ret = new Date(returnDate);
  ret.setHours(returnHours, returnMinutes, 0, 0);

  return ret.getTime() > pickup.getTime();
};
